/* TuMundoPet · carrusel del hero. Sin librería: tres slides, avance automático,
   se detiene al pasar el cursor y respeta prefers-reduced-motion. */
(function () {
  'use strict';
  const pista = document.getElementById('hero');
  if (!pista) return;
  const slides = Array.from(pista.querySelectorAll('.hero-slide'));
  const dots = Array.from(pista.querySelectorAll('.hero-dot'));
  if (slides.length < 2) return;

  const dur = parseInt(pista.dataset.dur || '7000', 10);
  const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let i = 0, t = null;

  function a(n) {
    i = (n + slides.length) % slides.length;
    slides.forEach((s, k) => s.classList.toggle('on', k === i));
    dots.forEach((d, k) => {
      d.classList.remove('on');
      if (k === i) { void d.offsetWidth; d.classList.add('on'); }  // reinicia la barra de progreso
    });
    reloj();
  }
  function reloj() { clearTimeout(t); if (!quieto) t = setTimeout(() => a(i + 1), dur); }

  pista.querySelectorAll('[data-hero]').forEach(b =>
    b.addEventListener('click', () => a(i + parseInt(b.dataset.hero, 10))));
  pista.querySelectorAll('[data-hero-a]').forEach(b =>
    b.addEventListener('click', () => a(parseInt(b.dataset.heroA, 10))));
  pista.addEventListener('mouseenter', () => clearTimeout(t));
  pista.addEventListener('mouseleave', reloj);
  document.addEventListener('visibilitychange', () => document.hidden ? clearTimeout(t) : reloj());

  dots[0].style.setProperty('--dur', dur + 'ms');
  dots.forEach(d => d.style.setProperty('--dur', dur + 'ms'));
  reloj();
})();
